export default __webpack_public_path__ + "static/Austin-Roman-491585a81c2b9420b9b7b8af2c3adc75.woff2";